<template>
    <q-form ref="form" class="full-width q-gutter-md">
        <q-input v-model="form.email"
                 class="full-width"
                 outlined
                 type="email"
                 bg-color="white"
                 :label="$t('personalInfo.email')"
                 :rules="emailRules" />

        <q-input v-model="form.password"
                 class="full-width"
                 outlined
                 bg-color="white"
                 :type="isPwd ? 'password' : 'text'"
                 :label="$t('personalInfo.password')"
                 :rules="passwordRules">
            <template #append>
                <i class="cursor-pointer"
                   :class="isPwd ? 'far fa-eye-slash' : 'far fa-eye'"
                   @click="isPwd = !isPwd"></i>
            </template>
        </q-input>

        <q-btn class="full-width"
               outline
               style="color: white"
               :label="$t('generic.text.login')"
               :loading="loginLoading"
               @click="onLogin" />

        <div class="divider full-width">{{ $t('generic.text.or') }}</div>

        <q-btn class="full-width"
               outline
               style="color: white"
               :label="$t('generic.text.register')"
               :to="{ name: 'Register' }" />
        <q-btn class="full-width"
               outline
               style="color: white"
               :label="$t('generic.text.forgetPassword')"
               :to="{ name: 'ForgetPassword' }" />
    </q-form>

    <div id="nativeElement"></div>
</template>

<script>
    import { mapActions } from 'vuex';

    import { RESOURCE_STATE } from '@/constants';

    export default {
        created() {
            window.onAndroidLogin = this.onAndroidLogin;
        },

        data() {
            return {
                isPwd: true,
                form: {
                    email: '',
                    password: '',
                },
                emailRules: [
                    (v) =>
                        !!v ||
                        this.$t('generic.error.required', {
                            msg: this.$t('personalInfo.email'),
                        }),
                ],
                passwordRules: [
                    (v) =>
                        !!v ||
                        this.$t('generic.error.required', { msg: this.$t('login.password') }),
                ],
                loginState: RESOURCE_STATE.IDLE,
            };
        },
        computed: {
            loginLoading() {
                return this.loginState === RESOURCE_STATE.PENDING;
            },
        },
        methods: {
            ...mapActions({
                login: 'user/login',
            }),
            onLogin() {
                this.$refs.form.validate().then((success) => {
                    if (!success) return;

                    this.loginState = RESOURCE_STATE.PENDING;
                    this.login(this.form)
                        .then(() => {
                            this.loginState = RESOURCE_STATE.RESOLVED;
                            this.$router.push(this.$route?.redirectedFrom?.fullPath || '/');
                        })
                        .catch((err) => {
                            console.log(err);

                            this.loginState = RESOURCE_STATE.REJECTED;
                            this.$notify.create({
                                message: this.$t('login.failed'),
                                caption: err.response.data,
                                position: 'top',
                                type: 'negative',
                            });
                        });
                });
            },

            //
            onAndroidLogin(email, password) {
                let json = {
                    'isSucceed': null
                };

                if (email === undefined || password === undefined) {

                    json['isSucceed'] = false;
                    return JSON.stringify(json);
                }
                if (email === '' && password === '') {

                    json['isSucceed'] = false;
                    return JSON.stringify(json);
                }

                this.loginState = RESOURCE_STATE.PENDING;

                let target = {};
                let handler = {
                    get(target, key) {
                        return target[key];
                    },
                    set(target, key, value) {
                        target[key] = value;
                        return true;
                    }
                };
                let formProxy = new Proxy(target, handler);
                formProxy.email = email;
                formProxy.password = password;

                this.login(formProxy).then(() => {
                    json['isSucceed'] = true;

                    this.loginState = RESOURCE_STATE.RESOLVED;
                    this.$router.push(this.$route?.redirectedFrom?.fullPath || '/');
                }).catch((err) => {
                    console.log(err);
                    json['isSucceed'] = false;

                    this.loginState = RESOURCE_STATE.REJECTED;
                    this.$notify.create({
                        message: this.$t('login.failed'),
                        caption: err.response.data,
                        position: 'top',
                        type: 'negative',
                    });
                }).finally(() => {
                    return JSON.stringify(json);
                });
            }

        },
        mounted() {
            const nativeElement = document.getElementById('nativeElement');
            //nativeElement.innerHTML = navigator.userAgent;
        },
    };
</script>
